import { useEffect } from "react";
import environment from "../environments/environment.json";

const BrowserCloseHandler = () => {
  // Function to send beacon data

  function sendBeaconData(eventType) {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token") ?? params.get("vq_tid");
    const supplierToken = params.get("vq_token");
    const path = window.location.pathname;
    const url = `${environment.BASE_RF_API_URL}/api/v1/browser/log`; // Update to your server endpoint
    const data = JSON.stringify({
        event: eventType,
        token:token,
        path:path,
        params:params,
        supplierToken:supplierToken,
        url:window.location.href,
        logTime: new Date().toISOString(),
        userAgent: navigator.userAgent,
        // sessionId: Math.random().toString(36).substring(2) // Random session ID for tracking
    });
  
    // Attempt to send beacon
    const success = navigator.sendBeacon(url, data);
  
    // Fallback for browsers where sendBeacon fails
    if (!success) {
        console.warn(`Beacon (${eventType}) failed, falling back to fetch`);
        fetch(url, {
            method: 'POST',
            body: data,
            headers: { 'Content-Type': 'application/json' },
            keepalive: true // Ensures request survives page unload
        }).catch(err => console.error(`Fetch fallback (${eventType}) failed:`, err));
    }
  }
  useEffect(() => {
    const handleUnload = () => sendBeaconData('unload');
    const handlePageHide = () => sendBeaconData('pagehide');
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        sendBeaconData('visibilityhidden');
      }
    };
  
    window.addEventListener('unload', handleUnload);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('visibilitychange', handleVisibilityChange);
  
    return () => {
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return null; // This component doesn’t render anything
};

export default BrowserCloseHandler;
